import { render, staticRenderFns } from "./headingBlock.vue?vue&type=template&id=45cf8e84&scoped=true"
import script from "./headingBlock.vue?vue&type=script&lang=js"
export * from "./headingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf8e84",
  null
  
)

export default component.exports